import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

interface NavItemProps {
  label: string;
  path: string;
  icon?: string;
  isChild?: boolean;
}

const NavItem: React.FC<NavItemProps> = ({
  label,
  path,
  icon,
  isChild = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname === path;

  return (
    <div
      className={`nav-item ${isActive ? "active" : ""} ${
        isChild ? "child" : ""
      }`}
      onClick={() => navigate(path)}
    >
      {icon && (
        <span className="nav-item__icon">
          <img src={icon} alt={`${label} icon`} className="nav-icon" />
        </span>
      )}
      <span className="nav-item__label">{label}</span>
    </div>
  );
};

export default NavItem;
